"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _styledSystem = require("styled-system");

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _Box = _interopRequireDefault(require("../Box"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  ", ";\n  ", "\n  ", "\n  ", ";\n  ", ";\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  display: inline-flex;\n  align-items: center;\n  letter-spacing: 0px;\n  text-transform: uppercase;\n  transition: all 0.125s ease-out;\n  text-align: center;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  cursor: pointer;\n  &:hover {\n    box-shadow: 0 0 0 2px ", ";\n    background: white;\n    color: blue;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

// adding close icon
// import IconERemove from '../icons/e-remove'
// const Icon = styled(IconERemove)`
//   width: 10px;
//   height: 10px;
// `
// default variant
var tagStyle = (0, _styledSystem.variant)({
  key: 'tagStyles'
}); // default variant

var tagSize = (0, _styledSystem.variant)({
  key: 'tagStyles.tagSizes',
  prop: 'tagSize'
}); // status

var status = {
  priority: (0, _styledSystem.variant)({
    key: 'tagStyles.priority.status',
    prop: 'status'
  }),
  intent: (0, _styledSystem.variant)({
    key: 'tagStyles.intent.status',
    prop: 'status'
  })
}; // hover state

var hoverState = (0, _styledComponents.css)(_templateObject(), function (props) {
  return props.theme.colors.action;
});
var tagBaseStyling = (0, _styledComponents.css)(_templateObject2());
var TagBase = (0, _styledComponents["default"])(_Box["default"])(_templateObject3(), tagBaseStyling, tagStyle, tagSize, function (props) {
  return status[props.variant];
}, function (props) {
  return props.interactive && hoverState;
});

var Tag = function Tag(_ref) {
  var children = _ref.children,
      variant = _ref.variant,
      status = _ref.status,
      icon = _ref.icon,
      rest = _objectWithoutProperties(_ref, ["children", "variant", "status", "icon"]);

  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(TagBase, _extends({
    showIcon: true,
    variant: variant,
    status: status
  }, rest), children ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, children) : /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, status)));
};

Tag.defaultProps = {
  borderRadius: 'pill',
  mr: 'xxsmall',
  tagSize: 'small',
  variant: 'default'
};
var _default = Tag;
exports["default"] = _default;